import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Button, Grid, Message} from 'semantic-ui-react';
import {actions as routerActions, routeNodeSelector} from 'redux-router5';

import {CurrencyValue} from 'Common/Format';
import {isPaymentsApp} from 'helpers';

const CompletePayment = props => {
  useEffect(() => {
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = () => {
      history.go(1);
    };
    return () => {
      window.onpopstate = () => {};
    };
  });

  const handleClose = () => {
    const oWnd = window.MHD.UI.RadWindow.getRadWindow();

    if (oWnd) {
      window.MHD.UI.RadWindow.makeCurrentWinDirty();
      oWnd.close('PAY-SUCCESS');
    } else if (window !== window.parent) {
      window.parent.postMessage(
        'PAY-SUCCESS',
        window.MHD.Global.Configuration.BaseUrl,
      );
    } else {
      window.location.href = '/';
    }
  };

  const handleDevClose = () => props.navigateTo('home');

  const {
    amount,
    estimateNumber,
    invoiceNumber,
    portalName,
    square,
  } = props.router.route.params;

  return (
    <Grid>
      <Grid.Column only="computer" width={5} />

      <Grid.Column
        computer={6}
        mobile={16}
        style={{textAlign: 'center'}}
        tablet={16}
      >
        <Message success>
          <Message.Header>
            Your transaction was successfully submitted!
          </Message.Header>

          {amount &&
            (estimateNumber || invoiceNumber) &&
            portalName && (
              <p>
                You have made a Payment of{' '}
                <strong>
                  <CurrencyValue value={amount} />
                </strong>{' '}
                to <strong>{portalName}</strong> for{' '}
                {invoiceNumber
                  ? `Invoice #${invoiceNumber}`
                  : `Estimate #${estimateNumber}`}. Please keep it for your
                records.
              </p>
            )}
        </Message>

        {square === true || square === 'true' ? (
          <p>
            Uncaptured Square transactions expire in <strong>6 days</strong>.
          </p>
        ) : null}

        {!isPaymentsApp() && (
          <Button
            content="Close"
            onClick={process.env.HOT_DEV ? handleDevClose : handleClose}
            primary
          />
        )}
      </Grid.Column>
    </Grid>
  );
};

CompletePayment.propTypes = {
  router: PropTypes.object.isRequired,

  // functions
  navigateTo: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  ...routeNodeSelector('payment')(state),
  router: state.router,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      navigateTo: routerActions.navigateTo,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CompletePayment);



// WEBPACK FOOTER //
// ./src/components/Payments/PaymentCollection/components/PaymentForm/CompletePayment.js